import { Tab, Tabs } from "@mui/material";
import * as Text from "./LeadAssignmentsTabs.text";

export type LeadAssignmentsTab = "open" | "unassigned" | "closed";

interface LeadAssignmentsTabsProps {
	currentTab: LeadAssignmentsTab;
	isAdmin?: boolean;
	handleTabChange?: (tab: LeadAssignmentsTab) => void;
	toggleLeads?: () => void;
}

export const LeadAssignmentsTabs = ({
	currentTab,
	isAdmin = false,
	handleTabChange,
	toggleLeads
}: LeadAssignmentsTabsProps) => {
	const availableTabs: LeadAssignmentsTab[] = isAdmin ? ["unassigned", "open", "closed"] : ["open", "closed"];
	const currentTabIndex = Math.max(
		availableTabs.findIndex((tab) => tab === currentTab),
		0
	);

	return (
		<Tabs
			value={currentTabIndex}
			onChange={(_event, value: number) => {
				const nextTab = availableTabs[value];
				if (nextTab) {
					if (handleTabChange) {
						handleTabChange(nextTab);
						return;
					}

					toggleLeads?.();
				}
			}}
		>
			{isAdmin && <Tab label={Text.UnassignedLeadsText} />}
			<Tab label={Text.OpenLeadsText} />
			<Tab label={Text.ClosedLeadsText} />
		</Tabs>
	);
};
